import {
  createPopoverStore
} from "./CUW3E24J.js";
import {
  createStore
} from "./BOKMNDR7.js";
import {
  defaultValue
} from "./NWU4GBZ6.js";
import {
  __spreadProps,
  __spreadValues
} from "./4BKCJXBM.js";

// src/hovercard/hovercard-store.ts
function createHovercardStore(props = {}) {
  var _a;
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  const timeout = defaultValue(props.timeout, syncState == null ? void 0 : syncState.timeout, 500);
  const popover = createPopoverStore(__spreadProps(__spreadValues({}, props), {
    placement: defaultValue(
      props.placement,
      syncState == null ? void 0 : syncState.placement,
      "bottom"
    )
  }));
  const initialState = __spreadProps(__spreadValues({}, popover.getState()), {
    timeout,
    showTimeout: defaultValue(
      props.showTimeout,
      syncState == null ? void 0 : syncState.showTimeout,
      timeout
    ),
    hideTimeout: defaultValue(
      props.hideTimeout,
      syncState == null ? void 0 : syncState.hideTimeout,
      timeout
    ),
    autoFocusOnShow: defaultValue(syncState == null ? void 0 : syncState.autoFocusOnShow, false)
  });
  const hovercard = createStore(initialState, popover, props.store);
  hovercard.setup(
    () => hovercard.sync(
      (state) => {
        hovercard.setState("showTimeout", (value) => value != null ? value : state.timeout);
        hovercard.setState("hideTimeout", (value) => value != null ? value : state.timeout);
      },
      ["timeout"]
    )
  );
  return __spreadProps(__spreadValues(__spreadValues({}, popover), hovercard), {
    setAutoFocusOnShow: (value) => hovercard.setState("autoFocusOnShow", value)
  });
}

export {
  createHovercardStore
};
